import { FigureShopify } from '@studiometa/ui';

/**
 *
 */
export default class Figure extends FigureShopify {
  static config = {
    ...FigureShopify.config,
    name: 'Figure',
    options: {
      ...FigureShopify.config.options,
      quality: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   * Format the source for Shopify CDN API with quality support.
   * @see https://shopify.dev/docs/api/liquid/filters/image_url
   * @param {string} src
   * @returns {string}
   */
  formatSrc(src) {
    const url = new URL(super.formatSrc(src));
    const { quality } = this.$options;

    if (quality) {
      url.searchParams.set('quality', String(quality));
    }

    return url.toString();
  }
}
